import type { Map as MapSDK } from "@maptiler/sdk";
import { GLOBE_MAX_ZOOM } from "../../tiles/constants";

export type GridSizeAndDimensions = {
  gridSize: number;
  resolutionScaleFactor: number;
  // this is used to calibrate the texture size in ParticleLayer
  // because when we add more tiles we lose resolution
};

export function getGridSizeForPitchAndMapDimensions(pitch: number, map: MapSDK) {
  const zoom = map.getZoom();
  const { width, height } = map.getCanvas().getBoundingClientRect();

  const resolutionScaleFactor = getResolutionScaleFactor(zoom, { width, height });
  const gridSize = pitch > 30 ? 9 : 3 * resolutionScaleFactor;
  return {
    gridSize,
    resolutionScaleFactor,
  };
}

type MapSize = {
  width: number;
  height: number;
};

function getResolutionScaleFactor(zoom: number, mapTransformSize: MapSize): number {
  // if we are viewing the enture globe we can use standard resolution

  if (zoom <= GLOBE_MAX_ZOOM - 1) {
    return 1;
  }

  // // if the screen height / width is less than a threshold we can use standard resolution
  if (mapTransformSize.width < 918 && mapTransformSize.height > 1020) {
    return 1;
  }

  // // if the screen width is less than a threshold we can use standard resolution
  if (mapTransformSize.width < 918) {
    return 1;
  }

  // otherwise we double the number of tiles and the resolution
  return 2;
}
